import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';
import { ButtonBaseThemed, ButtonProps, themeGet } from '@packages/ui';

export const StyledTextRow = styled.div<{ color: string }>`
  font-size: ${themeGet.fontSize(6)};
  text-align: left;
  color: ${(props) => props.color}};
`;

export const StyledTitle = styled(StyledTextRow)`
  font-family: ${themeGet.fonts('brand')};
  font-weight: ${themeGet.fontWeight('normal')};
  margin: 16px 0px 8px 0;
`;

export const StyledInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
  width: 100%;
  overflow-x: auto;
`;

export const FilterCTAButton = styled(ButtonBaseThemed)<ButtonProps & SpaceProps>`
  ${space};
`;
